<template>
    <v-row no-gutters>
        <v-col class="d-flex align-center col-auto pr-3">
            <span>Tableau d'amortissement ({{ deadlines.length }} échéances)</span>
        </v-col>
        <v-col class="pl-2 d-flex align-center">
            <v-divider />
        </v-col>
        <v-col cols="1" class="pl-2 d-flex align-center justify-end">
            <v-btn-add-icon size="x-small" @click="newAmountDue()"> </v-btn-add-icon>
        </v-col>
    </v-row>
    <v-row no-gutters v-if="errorCount">
        <v-col class="d-flex align-center col-auto">
            <span style="color: red">Nombre d'erreur(s) : {{ errorCount }}</span>
        </v-col>
        <v-spacer />
        <!-- <v-col class="pl-2 d-flex align-center">
                <v-divider></v-divider>
            </v-col> -->
        <v-col cols="2" class="pl-2 d-flex align-center justify-end">
            <v-switch hide-details="auto" v-model="filterErrors" class="mt-0" label="Filtrer" />
        </v-col>
    </v-row>
    <v-row no-gutters>
        <v-col cols="12">
            <v-list
                style="background-color: transparent; overflow-y: auto"
                width="100%"
                height="438"
            >
                <!-- <v-virtual-scroll
                        :item-height="75"
                        :items="identifiedBankTransactions"
                        height="350"
                        class="py-3"
                        bench="2"
                    >
                        <template v-slot="{ item, index }">
                            <v-lazy
                                v-model="item.isActive"
                                :options="{
                                    threshold: .5
                                }"
                                transition="fade-transition"
                            > -->
                <v-list-item
                    v-for="deadline in filteredDeadlines"
                    :key="deadline.index"
                    :class="
                        deadline.focus
                            ? 'oss-list-item1-high mb-2'
                            : !deadline.errorCount
                              ? 'oss-list-item1 mb-2'
                              : 'oss-list-item1-error mb-2'
                    "
                    @click.stop="toEditDeadline = deadline"
                    @mouseover="deadline.highlightBT(true, 'svg')"
                    @mouseout="deadline.highlightBT(false)"
                    :id="'identified-loan-' + deadline.index"
                    :active="false"
                    :link="false"
                >
                    <!-- <v-row no-gutters>
                        <v-col cols="12" class="d-flex pb-1 font-weight-bold align-center">
                            <v-btn-icon
                                color="primary"
                                @click.stop="item.selected = !item.selected"
                                size="small"
                                :icon="item.selected ? '$oss-circle-check' : '$oss-circle-uncheck'"
                            >
                            </v-btn-icon>
                            <div style="overflow: hidden">
                                {{ item.wording }}
                            </div>
                        </v-col>
                    </v-row> -->
                    <!-- <v-row no-gutters>
                        <v-col
                            cols="12"
                            class="d-flex pb-1 font-weight-bold align-center"
                            v-if="isDuplicates(item.index)"
                        >
                            <v-icon :color="!removeDuplicates ? 'red' : 'green'" size="small">
                                $report_problem
                            </v-icon>
                            <span
                                class="pl-2"
                                :style="!removeDuplicates ? 'color:red;' : 'color:green'"
                                >{{ !removeDuplicates ? "Doublon" : "Doublon retiré" }}</span
                            >
                        </v-col>
                    </v-row> -->
                    <v-row no-gutters>
                        <v-col cols="1" class="d-flex align-center">
                            <v-btn-icon
                                color="primary"
                                @click.stop="deadline.selected = !deadline.selected"
                                size="small"
                                :icon="
                                    deadline.selected ? '$oss-circle-check' : '$oss-circle-uncheck'
                                "
                            >
                            </v-btn-icon>
                        </v-col>
                        <v-col cols="2" class="pl-1 d-flex align-center">
                            <!-- <v-icon  size="small" left color="primary">$oss-calendar</v-icon> -->
                            <span :style="deadline.dateStyle"> {{ deadline.formatDate }}</span>
                        </v-col>
                        <v-col cols="2" class="pl-1 d-flex align-center justify-end">
                            <span>{{ newCommonFormatCurrency(deadline.capital) }}</span>
                        </v-col>
                        <v-col cols="2" class="pl-1 d-flex align-center justify-end">
                            <span>{{ newCommonFormatCurrency(deadline.interests) }}</span>
                        </v-col>
                        <v-col cols="2" class="pl-1 d-flex align-center justify-end">
                            <span>{{ newCommonFormatCurrency(deadline.insurance) }}</span>
                        </v-col>
                    </v-row>
                </v-list-item>
                <!-- </v-lazy> -->
                <!-- </template> -->
                <!-- </v-virtual-scroll> -->
            </v-list>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import _ from "lodash";

// import getEnv from "../../env";
import { Component, Vue, toNative, Prop, Watch } from "vue-facing-decorator";
import { newCommonFormatCurrency } from "@/services/mathServices";
import { LoanDeadLine } from "@/services/loan/loanDeadLine";

// const env = getEnv();

@Component({
    emits: ["", ""],
})
export class DocumentLoanOCR extends Vue {
    @Prop({ default: null }) document!: any;
    @Prop({ default: null }) analysis!: any;
    @Prop({ default: null }) deadlines!: LoanDeadLine[];

    filterErrors: boolean = false;

    get errorCount(): number {
        let errorCount = 0;
        for (const deadline of this.deadlines) {
            errorCount += deadline.errorCount || 0;
        }
        return errorCount;
    }

    get filteredDeadlines(): LoanDeadLine[] {
        if (this.filterErrors) {
            const deadlines = [];
            for (const deadline of this.deadlines) {
                if (this.filterErrors) {
                    if (deadline.errorCount) {
                        deadlines.push(deadline);
                    }
                }
            }
            return deadlines;
        }
        return this.deadlines;
    }

    get toEditDeadline() {
        return LoanDeadLine.toEdit;
    }

    set toEditDeadline(value: LoanDeadLine) {
        LoanDeadLine.selected = value;
        // LoanDeadLine.toEdit = value;
    }

    newAmountDue() {}

    onClickAmountDue(item) {
        // this.selectedBT = item;
        // this.editBT = {
        //     index: -1,
        //     focus: this.selectedBT.focus,
        //     selected: this.selectedBT.selected,
        //     dateDebit: this.selectedBT.dateDebit,
        //     dateRealization: this.selectedBT.dateRealization,
        //     amountSigned: this.selectedBT.amountSigned,
        //     wording: this.selectedBT.wording,
        // };
        // this.btDialog = true;
    }

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }
}

export default toNative(DocumentLoanOCR);
</script>
<style lang="scss" scoped>
.oss-list-item1 {
    background-color: #e5e5e5 !important;
    border: 1px #ededed solid !important;
    border-radius: 8px !important;
}

.oss-list-item1-high {
    background-color: rgba(249, 177, 42, 0.5) !important;
    border: 1px #f9b12a solid !important;
    border-radius: 8px !important;
}
.oss-list-item1-error {
    background-color: rgba(255, 0, 0, 0.5) !important;
    border: 1px #f9b12a solid !important;
    border-radius: 8px !important;
}
</style>
